"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orders = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@headlessui/react");
var classnames_1 = __importDefault(require("classnames"));
var react_i18next_1 = require("react-i18next");
var react_toastify_1 = require("react-toastify");
var react_router_dom_1 = require("react-router-dom");
var Icons_1 = require("../Icons");
require("./style.scss");
var AsyncAutocomplete_1 = require("../../../components/AsyncAutocomplete");
var utils_1 = require("../../../utils/utils");
var Orders = function (_a) {
    var restaurants = _a.restaurants;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)({}), address = _b[0], setAddress = _b[1];
    var history = (0, react_router_dom_1.useHistory)();
    var keys = Object.keys(restaurants);
    var values = Object.values(restaurants);
    var restaurantsList = values.map(function (_a) {
        var restaurants = _a.restaurants;
        return restaurants;
    });
    var types = values.map(function (_a) {
        var type = _a.type;
        return type;
    });
    var onTapRestaurant = function (_a) {
        var is_open = _a.is_open, id = _a.id, type = _a.type;
        if (!is_open) {
            react_toastify_1.toast.info(t('Restaurant is closed'), {
                className: 'restaurant-is-closed',
                theme: 'dark',
                hideProgressBar: true,
                closeButton: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}),
            });
            return;
        }
        var URLParams = new URLSearchParams({ type: type });
        history.push({
            pathname: "/store/".concat(id),
            search: URLParams.toString(),
        });
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(react_2.Tab.Group, { children: [(0, jsx_runtime_1.jsx)(react_2.Tab.List, __assign({ className: "order-methods-container" }, { children: function (_a) {
                        var selectedIndex = _a.selectedIndex;
                        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "order-methods-tabs" }, { children: [keys.map(function (restaurant) { return ((0, jsx_runtime_1.jsxs)(react_2.Tab, __assign({ className: function (_a) {
                                        var selected = _a.selected;
                                        return (0, classnames_1.default)('order-method', { selected: selected });
                                    } }, { children: [restaurants[restaurant].icon, " ", restaurant] }), restaurant)); }), (0, jsx_runtime_1.jsx)("span", { className: "glider", style: {
                                        transform: "translateX(".concat(selectedIndex * 100, "%)"),
                                        width: "".concat(100 / keys.length, "%"),
                                    } })] })));
                    } })), (0, jsx_runtime_1.jsx)(react_2.Tab.Panels, __assign({ className: "" }, { children: function (_a) {
                        var selectedIndex = _a.selectedIndex;
                        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: restaurantsList.map(function (restaurants, idx) {
                                var isDelivery = types[selectedIndex] === 'delivery';
                                var filteredDeliveryRestaurants = restaurants.filter(function (restaurant) {
                                    var _a;
                                    if (!((_a = restaurant.point) === null || _a === void 0 ? void 0 : _a.coordinates) || !address.lng || !address.lat) {
                                        return false;
                                    }
                                    var point1 = {
                                        lng: restaurant.point.coordinates[0],
                                        lat: restaurant.point.coordinates[1],
                                    };
                                    var point2 = { lng: address.lng, lat: address.lat };
                                    var distance = (0, utils_1.getDistance)(point1, point2);
                                    return distance <= 3000;
                                });
                                var filteredRestaurants = isDelivery ? filteredDeliveryRestaurants : restaurants;
                                return ((0, jsx_runtime_1.jsxs)(react_2.Tab.Panel, __assign({ className: "order-restaurants" }, { children: [isDelivery ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ className: "header-title" }, { children: ["2. ", t('Enter your postcode')] })), (0, jsx_runtime_1.jsx)(AsyncAutocomplete_1.AsyncAutocomplete, { address: address, setAddress: setAddress }), filteredRestaurants.length > 0 && (0, jsx_runtime_1.jsxs)("p", __assign({ className: "header-title" }, { children: ["3. ", t('Choose a store')] }))] })) : ((0, jsx_runtime_1.jsxs)("p", __assign({ className: "header-title" }, { children: ["2. ", t('Choose a store')] }))), (0, jsx_runtime_1.jsx)("ul", { children: filteredRestaurants.map(function (_a) {
                                                var id = _a.id, name = _a.name, address = _a.address, is_open = _a.is_open, opens_at = _a.opens_at, closes_at = _a.closes_at;
                                                return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: "restaurant", onClick: function () {
                                                        return onTapRestaurant({
                                                            is_open: is_open,
                                                            id: id,
                                                            type: types[selectedIndex],
                                                        });
                                                    } }, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "restaurant-header" }, { children: name })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "restaurant-address" }, { children: address })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "restaurant-time" }, { children: [is_open ? (0, jsx_runtime_1.jsx)("span", __assign({ className: "restaurant-status opened" }, { children: t('Open') })) : (0, jsx_runtime_1.jsx)("span", __assign({ className: "restaurant-status closed" }, { children: t('Closed') })), opens_at && closes_at ? ": ".concat(opens_at, " - ").concat(closes_at) : null, opens_at && !closes_at ? ": ".concat(opens_at) : null, !opens_at && closes_at ? ": ".concat(closes_at) : null] }))] }), id));
                                            }) }), address.address && isDelivery && filteredRestaurants.length === 0 && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "empty-store" }, { children: [(0, jsx_runtime_1.jsx)(Icons_1.EmptyStore, {}), (0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-header" }, { children: t('There is no store nearby.') }))] })))] }), idx));
                            }) }));
                    } }))] }) }));
};
exports.Orders = Orders;
